import Vue from 'vue';
import { Component, Prop, Provide, Watch, Inject } from 'vue-property-decorator';
import * as Logger from 'js-logger';
import StageHeader from '../../components/stageHeader';
import Datepicker from 'vuejs-datepicker';
import UinsDefaultSelect from '../../components/unisDefaultSelect';
import template from './scheduleApickup.vue';
import MainButtonSet from '../../components/mainButtonSet';
import UnisProductModal from '../../components/unisProductModal';
import DefaultModal from '../../components/modal';
import PickupLocation from '../../components/pickupLocation';
import tmsService from '../../services/axios/tmsService';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import TmsDatepicker from '../../components/tmsDatepicker';
import qs from 'qs';
import { Validator } from 'vee-validate';
import Moment from 'moment';
import localStorageUtil from '../../services/localStorageUtil/localStorageUtil';
import isStateMatchPostcode from '../../validation/validateLocation/isStateMatchPostcode';
import googleAutoComplete from '../../services/googleAPI/autoComplete';
import { clone } from 'lodash-es';
import tmsTransformRequestService from '../../services/axios/tmsTransformRequestService';
import { Subject } from 'rxjs';
import switchBillingToService from '../../shared/switchBillingToService';
@Component({
    mixins: [template],
    components: {
        Datepicker,
        StageHeader,
        MainButtonSet,
        UinsDefaultSelect,
        UnisProductModal,
        PickupLocation,
        DefaultModal,
        TmsDatepicker,
    },
})
export default class ScheduleApickup extends Vue {
    truckloadForm: any = {};
    shipperLocation: any = '';
    consigneeLocation: any = '';
    userSource: any = false;
    prChangeRole: any = '';
    thirdPartyLocationObj: any = {
        location_name: '',
        location_street: '',
        location_zip: '',
        location_city: '',
        location_state: '',
        location_phone: '',
        location_email: '',
    };
    shipperLocationObj: any = {
        location_zip: '',
        location_city: '',
        location_state: '',
        location_name: '',
        location_street: '',
        location_phone: '',
        location_email: '',
    };
    consigneeLocationObj: any = {
        location_zip: '',
        location_city: '',
        location_state: '',
        location_name: '',
        location_street: '',
        location_phone: '',
        location_email: '',
    };

    showShipperLocationTip: Boolean = false;
    showConsigneeLocationTip: Boolean = false;
    // timeArr: any = [
    //     { label: '9:00AM - 12:00AM', value: "['9:00', '12:00']" },
    //     { label: '1:00PM - 5:00PM', value: "['13:00', '17:00']" }
    // ];
    timeArr: any = [];
    timeArr2: any = [
        '11:00 AM',
        '12:00 PM',
        '1:00 PM',
        '2:00 PM',
        '3:00 PM',
        '4:00 PM',
        '5:00 PM',
        '6:00 PM',
    ];
    freightChargesBillTo: any = 3;
    editProductModal: string = 'CreateNewCompanyAddress';
    locationArr: any = [];
    shipmentInfo: any = {
        shipment_has_batteries: 0,
        shipment_has_other_dangersL: 0,
        role: '',
    };
    //  payMent: 0,
    isShipper: Boolean = false;
    isConsignee: Boolean = false;
    isThirdParty: Boolean = false;
    quoteInfo: any = {};
    funPickupAddress: Subject<void> = new Subject();
    quoteId: any = '';
    submitQuote: any = {};
    addCompany: any = {};
    businessTypes: Array<any> = [
        { key: 1, code: null, title: 'Business' },
        { key: 2, code: 'CON', title: 'ConstructionSite' },
        { key: 3, code: 'SHOW', title: 'ConventionCenter' },
        { key: 4, code: null, title: 'FreightCarrierTerminal' },
        { key: 5, code: 'RES', title: 'Home/Residential' },
        { key: 6, code: null, title: 'MilitaryBase' },
        { key: 7, code: null, title: 'SelfStorage/MiniStorage' },
        { key: 8, code: null, title: 'ReligiousInstitution' },
    ];
    @Provide() stateOptions: any = this.$store.getters.stateOptions;
    @Inject() $validator: Validator;
    suggestedRadioPickup: String = 'inputted';
    suggestAddress: any = {};
    showErrTip: boolean = false;
    errorText: String = '';
    editParams: any = {};
    quoteData: any = {};
    disabledDates: any = {
        to: new Date(Date.now() - 8640000),
    };
    shipperLocationId: any = '';
    consigneeLocationId: any = '';
    thirdParyLocationId: any = '';
    tipType: string = '';
    billToId: any = '';
    shipperList: any = [];
    addNewShipper: Boolean = false;
    consigneeList: any = [];
    addNewConsignee: Boolean = false;

    mounted() {
        this.init();
        let localStoragPickupAddress = localStorageUtil.getItemFromStorage('pickupAddress');
        if (localStoragPickupAddress != null && this.quoteId == localStoragPickupAddress.quoteId) {
            this.shipperLocationObj.location_street = localStoragPickupAddress.location_street;
        }
        this.funPickupAddress.debounceTime(800).subscribe(this.privatePickupAddress, err => {});
        this.getEditData();

    }
    private privatePickupAddress() {
        localStorage.removeItem('pickupAddress');
        localStorage.setItem(
            'pickupAddress',
            JSON.stringify({
                quoteId: this.quoteId,
                location_street: this.shipperLocationObj.location_street,
            })
        );
    }

    getEditData() {
        this.editParams = localStorageUtil.getItemFromStorage('schedukeAPickup');
        this.quoteData = localStorageUtil.getItemFromStorage('quoteData_' + this.quoteId);
        if (this.editParams != undefined) {
            if (this.editParams.quoteId == this.quoteId) {
                this.shipmentInfo.appointment_date = Moment(
                    this.editParams.appointment_date
                ).format('MM/DD/yyyy');
                this.shipmentInfo.earliest_time = this.editParams.appointment_time;
                this.shipmentInfo.latest_time = this.editParams.appointment_time_to;
                this.changeTime();
                if (this.editParams.role == 'thirdparty') {
                    this.isThirdParty = true;
                    this.$nextTick(() => {
                        this.setGoogleAddressFill();
                    });
                    this.shipmentInfo.role = 2;
                }
                if (this.editParams.role == 'shipper') {
                    this.isShipper = true;
                    this.shipmentInfo.role = 0;
                }
                if (this.editParams.role == 'consignee') {
                    this.isConsignee = true;
                    this.shipmentInfo.role = 1;
                }
                if (this.editParams.shipper_contactless_active == '1') {
                    this.shipperLocationObj.contactlessShipper = true;
                }
                if (this.editParams.consignee_contactless_active == '1') {
                    this.consigneeLocationObj.contactlessShipper = true;
                }
                (this.thirdPartyLocationObj.location_name = this.editParams.thirdPartyLocation_name),
                    (this.thirdPartyLocationObj.location_street = this.editParams.thirdPartyLocation_street),
                    (this.thirdPartyLocationObj.location_zip = this.editParams.thirdPartyLocation_zip),
                    (this.thirdPartyLocationObj.location_city = this.editParams.thirdPartyLocation_city),
                    (this.thirdPartyLocationObj.location_state = this.editParams.thirdPartyLocation_state),
                    (this.thirdPartyLocationObj.location_phone = this.editParams.thirdPartyLocation_phone),
                    (this.thirdPartyLocationObj.location_email = this.editParams.thirdPartyLocation_email),
                    (this.shipperLocationObj.location_name = this.editParams.shipperLocation_name),
                    (this.shipperLocationObj.location_street = this.editParams.shipperLocation_street),
                    (this.shipperLocationObj.location_phone = this.editParams.shipperLocation_phone),
                    (this.shipperLocationObj.location_email = this.editParams.shipperLocation_email),
                    (this.consigneeLocationObj.location_name = this.editParams.consigneeLocation_name),
                    (this.consigneeLocationObj.location_street = this.editParams.consigneeLocation_street),
                    (this.consigneeLocationObj.location_phone = this.editParams.consigneeLocation_phone),
                    (this.consigneeLocationObj.location_email = this.editParams.consigneeLocation_email),
                    (this.shipperLocationId = this.editParams.pickupLocationId);
                this.consigneeLocationId = this.editParams.deliveryLocationId;
                // this.shipmentInfo.payMent = this.editParams.payMent;
                this.$forceUpdate();
            }
        }
        if (!this.shipmentInfo.role && this.quoteData) {
          const now = new Date();
          const endTime = this.quoteData.latest_time != undefined ? this.quoteData.latest_time : '00:00:00';
          const date = new Date(this.quoteData.appointment_date + 'T' +  endTime);
          if (this.quoteData != undefined && now.getTime() < date.getTime()) {
            if (this.quoteData.appointment_date) {
              this.shipmentInfo.appointment_date = Moment(
                this.quoteData.appointment_date
              ).format('MM/DD/yyyy');
            }
            if (this.quoteData.earliest_time) {
              this.shipmentInfo.earliest_time = this.quoteData.earliest_time;
            }
            if (this.quoteData.latest_time) {
              this.shipmentInfo.latest_time = this.quoteData.latest_time;
            }
          }
        }
    }

    init() {
        this.quoteId = this.$route.params.quoteId;
        this.getQuoteInfo();
        this.getUserBillToId();
        this.$validator.extend('stateMatchPostcode', {
            validate: isStateMatchPostcode,
            getMessage: (field: string, params: any, data: any) => {
                this.showErrorFun('The state does not match the postcode.');
                return data.message;
            },
        });
        this.timeArr = this.generateTimeArray();
    }

    getNameInfoByZipcode(zipCode: string | number) {
        let params: any = {
            zipCode: zipCode,
            companyName: '',
        };
        return new Promise((resolve: any, reject: any) => {
            tmsTransformRequestService
                .post(`write_new/get_customer_address_book.php`, qs.stringify(params))
                .then(
                    (res: any) => {
                        if (res.data.address_book.length > 0) {
                            resolve(res.data.address_book);
                        } else {
                            resolve([]);
                        }
                    },
                    (err: any) => {
                        reject([]);
                    }
                );
        });
    }

    chooseShipper(item: any) {
        this.shipperLocationObj.location_street = item.location_street;
        this.shipperLocationObj.location_phone = item.location_phone;
        this.shipperLocationObj.location_email = item.location_email;
    }

    chooseConsignee(item: any) {
        this.consigneeLocationObj.location_street = item.location_street;
        this.consigneeLocationObj.location_phone = item.location_phone;
        this.consigneeLocationObj.location_email = item.location_email;
    }

    addNewShipperInfo() {
        this.addNewShipper = !this.addNewShipper;
        this.shipperLocationObj.location_name = '';
        if (this.addNewShipper) {
            this.shipperLocationObj.location_street = '';
            this.shipperLocationObj.location_phone = '';
            this.shipperLocationObj.location_email = '';
        }
    }

    addNewConsigneeInfo() {
        this.addNewConsignee = !this.addNewConsignee;
        this.consigneeLocationObj.location_name = '';
        if (this.addNewConsignee) {
            this.consigneeLocationObj.location_street = '';
            this.consigneeLocationObj.location_phone = '';
            this.consigneeLocationObj.location_email = '';
        }
    }

    getUserBillToId() {
        switchBillingToService.post().then(
            (res: any) => {
                if (res.data.billing) {
                    this.billToId = res.data.billing.location_id;
                }
                if (res.data.user) {
                    if (
                        res.data.user.user_source &&
                        (res.data.user.user_source == 'self sign up without account code' ||
                            res.data.user.user_source == 'google' ||
                            res.data.user.user_source == 'facebook')
                    )
                        this.userSource = true;
                }
            },
            (err: any) => {
                console.log(err);
            }
        );
    }

    async setGoogleAddressFill() {
        if (document.getElementById('googleZip') == null) {
            return;
        }
        let autoComplete = new googleAutoComplete('googleZip');
        autoComplete.setShortStateName();
        while (true) {
            let result: any = await autoComplete.searchResult();
            this.thirdPartyLocationObj.location_zip = result.postal_code;
            this.thirdPartyLocationObj.location_city = result.city;
            this.thirdPartyLocationObj.location_state = result.state;
            this.$forceUpdate();
        }
    }

    closeModal() {
        this.$modal.hide(this.editProductModal);
    }

    changeTime() {}

    selectShipperItem(item: any) {
        this.shipperLocationObj = item;
        if (item.location_zip != this.quoteInfo.tms_quote_client_zip) {
            this.showShipperLocationTip = true;
        } else {
            this.showShipperLocationTip = false;
        }
        this.$forceUpdate();
    }

    selectConsigneeItem(item: any) {
        this.consigneeLocationObj = item;
        if (item.location_zip != this.quoteInfo.tms_quote_consignee_zip) {
            this.showConsigneeLocationTip = true;
        } else {
            this.showConsigneeLocationTip = false;
        }
        this.$forceUpdate();
    }

    noDanger() {
        if (this.shipmentInfo.no_dangers) {
            this.shipmentInfo.shipment_has_batteries = false;
            this.shipmentInfo.shipment_has_other_dangers = false;
        }
    }

    changeRole(item: any, value: any) {
        this.isShipper = false;
        this.isConsignee = false;
        this.isThirdParty = false;
        this[item] = true;
        this.prChangeRole = clone(item);
        this.shipmentInfo.role = value;
        if (this.isThirdParty) {
            this.$nextTick(() => {
                this.setGoogleAddressFill();
            });
        }
    }

    setPayMent(item: any) {
        if (this.userSource && item == '1') return;
        this.shipmentInfo.payMent = item;
    }

    withDanger() {
        if (
            !this.shipmentInfo.shipment_has_batteries ||
            !this.shipmentInfo.shipment_has_other_dangers
        ) {
            this.shipmentInfo.no_dangers = false;
        }
    }

    getQuoteInfo() {
        tmsService
            .post(`/write_new/get_tms_quote_line.php`, qs.stringify({ quote_id: this.quoteId }))
            .then(
                async (res: any) => {
                    this.quoteInfo = res.data;
                    this.shipperLocationObj.location_zip = this.quoteInfo.tms_quote_client_zip;
                    this.shipperLocationObj.location_city = this.quoteInfo.tms_quote_client_city;
                    this.shipperLocationObj.location_state = this.quoteInfo.tms_quote_client_state;
                    this.consigneeLocationObj.location_zip = this.quoteInfo.tms_quote_consignee_zip;
                    this.consigneeLocationObj.location_city = this.quoteInfo.tms_quote_consignee_city;
                    this.consigneeLocationObj.location_state = this.quoteInfo.tms_quote_consignee_state;
                    this.shipperList = await this.getNameInfoByZipcode(
                        this.shipperLocationObj.location_zip
                    );
                    this.consigneeList = await this.getNameInfoByZipcode(
                        this.consigneeLocationObj.location_zip
                    );
                    this.$forceUpdate();
                },
                (err: any) => {
                    this.err(err.response.data.statusText);
                }
            );
    }

    async submit() {
        this.privatePickupAddress();
        this.tipType = 'tip-inprogress';
        this.showErrorFun('saving location, please wait a moment.');
        this.shipperLocationId = await this.saveAddressBeforeContinue(this.shipperLocationObj);
        this.consigneeLocationId = await this.saveAddressBeforeContinue(this.consigneeLocationObj);
        if (this.isThirdParty) {
            this.thirdParyLocationId = await this.saveAddressBeforeContinue(
                this.thirdPartyLocationObj
            );
        }
        this.tipType = '';
        if (!this.shipperLocationId || !this.consigneeLocationId) {
            this.showErrorFun('Save location error.');
            return;
        }
        if (this.isThirdParty && !this.thirdParyLocationId) {
            this.showErrorFun('Save location error.');
            return;
        }
        // let billto_id: any = '';
        // if (this.isThirdParty) {
        //     billto_id = this.thirdParyLocationId;
        // } else {
        //     if (this.shipmentInfo.payMent == 0) {
        //         billto_id = this.shipperLocationId;
        //     } else {
        //         billto_id = this.consigneeLocationId;
        //     }
        // }
        let params: any = {
            quoteId: this.quoteId,
            appointment_date: Moment(this.shipmentInfo.appointment_date).format('YYYY-MM-DD'),
            shipper_contactless_active: this.shipperLocationObj.contactlessShipper ? '1' : '0',
            consignee_contactless_active: this.consigneeLocationObj.contactlessDelivery ? '1' : '0',
            shipper_contactless_id: 0,
            consignee_contactless_id: 0,
            billto_id: this.billToId,
            role: this.isShipper ? 'shipper' : this.isConsignee ? 'consignee' : 'thirdparty',
            appointment_time: Moment('06/20/2021' + ' ' + this.shipmentInfo.earliest_time).format(
                'HH:mm'
            ),
            appointment_time_to: Moment('06/20/2021' + ' ' + this.shipmentInfo.latest_time).format(
                'HH:mm'
            ),
            pickupLocationId: this.shipperLocationId,
            thirdPartyLocation_name: this.thirdPartyLocationObj.location_name,
            thirdPartyLocation_street: this.thirdPartyLocationObj.location_street,
            thirdPartyLocation_zip: this.thirdPartyLocationObj.location_zip,
            thirdPartyLocation_city: this.thirdPartyLocationObj.location_city,
            thirdPartyLocation_state: this.thirdPartyLocationObj.location_state,
            thirdPartyLocation_phone: this.thirdPartyLocationObj.location_phone,
            thirdPartyLocation_email: this.thirdPartyLocationObj.location_email,
            reference: this.shipmentInfo.reference,
            po: this.shipmentInfo.po,

            shipper_phone: this.shipperLocationObj.location_phone,
            shipperLocation_name: this.shipperLocationObj.location_name,
            shipperLocation_street: this.shipperLocationObj.location_street,
            shipperLocation_phone: this.shipperLocationObj.location_phone,
            shipperLocation_email: this.shipperLocationObj.location_email,

            consignee_phone: this.consigneeLocationObj.location_phone,
            consigneeLocation_name: this.consigneeLocationObj.location_name,
            consigneeLocation_street: this.consigneeLocationObj.location_street,
            consigneeLocation_phone: this.consigneeLocationObj.location_phone,
            consigneeLocation_email: this.consigneeLocationObj.location_email,
            deliveryLocationId: this.consigneeLocationId,
        };
        // payMent: this.shipmentInfo.payMent
        localStorageUtil.setItemToStorage('schedukeAPickup', params);
        let data = {
          appointment_date: Moment(this.shipmentInfo.appointment_date).format('YYYY-MM-DD'),
          earliest_time: Moment('06/20/2021' + ' ' + this.shipmentInfo.earliest_time).format(
            'HH:mm'
          ),
          latest_time: Moment('06/20/2021' + ' ' + this.shipmentInfo.latest_time).format(
            'HH:mm'
          )
        };
        localStorageUtil.setItemToStorage('quoteData_' + this.quoteId, data);
        this.$router.replace({
            name: 'ReviewPickupRequest',
            params: {
                id: this.quoteId,
            },
        });
    }
    async continueShipment() {
        this.$validator.validateAll().then(res => {
            this.validateErrors(this);
            if (res) {
                this.submit();
            }
        });
    }

    async saveAddressBeforeContinue(address: any) {
        return new Promise((resolve: any, reject: any) => {
            tmsServiceBackend.post(`/address/save`, qs.stringify(address)).then(
                (res: any) => {
                    if (res.data.data.location_id) {
                        resolve(res.data.data.location_id);
                    } else {
                        this.err(res.data.message);
                        resolve('');
                    }
                },
                (err: any) => {
                    this.err(err.response.data.statusText);
                    resolve('');
                }
            );
        });
    }

    addAddress() {
        this.editProductModal = 'CreateNewCompanyAddress';
        this.$modal.show(this.editProductModal);
    }

    saveAddress() {
        if (this.suggestedRadioPickup == 'suggested') {
            let address: any = {
                location_type: this.addCompany.location_type,
                locationName: this.addCompany.locationName,
                phone: this.addCompany.phone,
                email: this.addCompany.email,
                address1: this.suggestAddress.StreetAddress,
                city: this.suggestAddress.City,
                state: this.suggestAddress.State,
                zip: this.suggestAddress.Zip,
            };
            let params: any = this.formData(address);
            this.addNewLocation(params);
        } else {
            let params: any = this.formData(this.addCompany);
            this.addNewLocation(params);
        }
    }

    judgeLocation() {
        return new Promise((resolve: any, reject: any) => {
            tmsService
                .get(
                    `https://pcmiler.alk.com/apis/rest/v1.0/Service.svc/locations?street=${
                        this.addCompany.address1
                    }&city=${this.addCompany.city}&state=${this.addCompany.state}&postcode=${
                        this.addCompany.zip
                    }&region=NA`,
                    { headers: { authorization: '9A4DC5EC2EFCEA4C8917545360589148' } }
                )
                .then(
                    (res: any) => {
                        resolve(res.data[0]);
                    },
                    (err: any) => {
                        this.err(err.response.data.statusText);
                    }
                );
        });
    }

    addNewLocation(params: any) {
        tmsService.post(`/write_new/write_location_admin.php`, qs.stringify(params)).then(
            (res: any) => {
                if (res.data.location_id) {
                    this.$modal.hide(this.editProductModal);
                    this.$modal.hide('CreateNewCompanyAddress');
                    this.editProductModal = 'createResultShow';
                    this.$modal.show(this.editProductModal);
                } else {
                    this.$modal.hide(this.editProductModal);
                    this.err(`error: errCode ${res.data}`);
                }
            },
            (err: any) => {
                this.err(err.response.data.statusText);
            }
        );
    }

    async saveNewLocation() {
        let judgeParam: any = {
            l_type: this.addCompany.location_type,
            l_locationName: this.addCompany.locationName,
            l_address1: this.addCompany.address1,
            l_city: this.addCompany.city,
            l_state: this.addCompany.state,
            l_zip: this.addCompany.zip,
            l_phone: this.addCompany.phone,
        };
        this.$validator.validateAll(judgeParam).then(res => {
            this.validateErrors(this);
            if (res) {
                this.judgeResultjudgeLocation();
            }
        });
    }

    async judgeResultjudgeLocation() {
        let judgeResult: any = await this.judgeLocation();
        this.suggestAddress = judgeResult.Address;
        if (!this.suggestAddress) {
            let params = this.formData(this.addCompany);
            this.addNewLocation(params);
        } else {
            this.editProductModal = 'suggestAddressDom';
            this.$modal.show(this.editProductModal);
        }
    }

    goQuotePage() {
        let type: string = '';
        if (this.quoteInfo.tms_quote_from == 'TMS_MILE_SERVICE') {
            type = 'truckload';
        } else {
            type = 'lastmile';
        }
        this.$router.push({
            name: 'Quote',
            query: {
                isEdit: 'true',
                quoteType: type,
                quoteNumber: this.quoteId,
            },
        });
    }

    closeTips() {
        this.showErrTip = false;
    }

    showErrorFun(errText: any) {
        this.errorText = errText;
        this.showErrTip = true;
        setTimeout(() => {
            this.showErrTip = false;
        }, 3000);
    }

    formData(address: any) {
        let data = {
            input_client_id: 0,
            input_location_address_book: 1,
            input_location_type_id: address.location_type,
            rec_id: 0,
            input_name: address.locationName,
            input_fax: address.fax,
            input_invoice_id: 0,
            input_czar_rate: 0,
            input_status: 1,
            input_phone: address.phone,
            input_email: address.email,
            input_timezone: 'PST',
            input_street: address.address1,
            input_street2: address.address2,
            input_city: address.city,
            input_state: address.state,
            input_zip: address.zip,
            input_country: 'US',
            input_lat: null,
            input_lng: null,
            input_server: 0,
            input_warehouse_id: 0,
            input_invoice_type: 'Standard',
            input_credit_score_grade: 0,
            input_netterm: 0,
            input_payment_type: 'cash',
            input_print_invoice_bol: 0,
            input_invoice_pod: 0,
            input_insurance_addl: 0,
            input_carrier_complete: 0,
            input_gps_contract: 0,
            input_watch: 0,
            input_intracompany: 0,
            input_production_line: 0,
            input_invoice_inoutgate: 0,
            input_invoice_mail: 0,
            input_email_update: -1,
            input_cust_quote: 0,
            input_customer_pickup: 0,
            input_location_notify: 0,
            input_revenue_id: 0,
            input_invoice_scale: 0,
            input_invoice_combine: 0,
            input_invoice_complete_move: 0,
            input_drop_and_hook: 0,
            input_link_terminal_id: 0,
            input_invoice_receipt: 0,
            input_dr_double_sided: 0,
            input_req_ref: 0,
            input_req_po: 0,
            input_req_do: 0,
            input_req_rate_conf: 0,
            input_cust_ref: 0,
            input_collage: 0,
            input_req_photo: 0,
            input_req_pc_count: 0,
            input_bobtail_override: 0,
            input_notify_email: 0,
            input_notify_phone: 0,
            input_notify_text: 0,
            input_notify_fax: 0,
            input_customer_group: 0,
            input_aging_format_difference: 30,
            input_statement_ref: 0,
            input_vendor: 0,
            input_accessorial_approval: 0,
            input_pu_notification: 0,
            input_dl_notification: 0,
            options_array: '[25]',
            location_shipper: 1,
            location_xml: 0,
            location_invoiceheader: 0,
            location_residential: 0,
            location_inside: 0,
            location_pickup_liftgate: 0,
            location_delivery_liftgate: 0,
            location_appointment: 0,
            location_sameday: 0,
            location_email_pod: 0,
            location_bobtail_override: 0,
            location_lh_carrier: 0,
            location_advanced_carrier: 0,
            location_beyond_carrier: 0,
            location_dray_carrier: 0,
            location_billto: 0,
            location_cfs: 0,
            location_warehouse: 0,
            location_xdock: 0,
            location_port: 0,
            location_chassisdepot: 0,
            location_parking: 0,
            location_steamship: 0,
            location_inventory: 0,
            location_vendor: 0,
            location_production_line: 0,
            pageName: 'LTL',
        };
        return data;
    }

    generateTimeArray() {
        const timeArr = [];
        for (let hour = 0; hour < 24; hour++) {
            for (let minute = 0; minute < 60; minute += 15) {
                const formattedHour = hour < 10 ? '0' + hour : '' + hour;
                const formattedMinute = minute < 10 ? '0' + minute : '' + minute;
                timeArr.push(`${formattedHour}:${formattedMinute}`);
            }
        }
        return timeArr;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/scheduleApickup/index.ts